import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { STATIC_STRINGS } from "@asez/shared";

const RenderError = ({
  onRetry,
  error,
}: {
  onRetry?: () => void;
  error?: any;
}) => {
  return (
    <div className=" h-full flex flex-col flex-1 items-center justify-center text-sm xl:text-base">
      <ErrorOutlineIcon color="error" fontSize="large" />
      <h2 className="text-lg font-semibold text-red-600 mt-2">
        {STATIC_STRINGS.ERROR_MESSAGE}
      </h2>
      <p className="text-gray-600 mt-1">{STATIC_STRINGS.TOPICS_API_ERROR}</p>
      <button onClick={onRetry} className="btn btn-outline mt-2">
        {STATIC_STRINGS.RETRY}
      </button>
    </div>
  );
};

export default RenderError;
